import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useChatContext } from 'stream-chat-react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Loader from 'components/core/Loader'
import Channel from '../Channel'
import UserProfile from '../UserProfile'
import ConversationActions from './ConversationActions'
import PhoneChannelHeader from './PhoneChannelHeader'
import { Screen, ScreenBar } from './Screen'
import { threadPath, useBack } from './navigation'

// The chat page on a phone: one screen at a time, as in iOS Messages. The
// list of threads fills the page. A tapped thread covers it and the nav,
// and the thread's profile (the desktop's right-hand column) covers the
// thread. Each is a history entry (?cid=, then &profile=1), so the back
// arrow and Safari's edge swipe both step back, and a reload or a link
// lands on the same screen. The list stays mounted underneath, so back
// lands where it was left. The pages behind the list header's buttons
// (create, attachments, broadcasts, welcome) cover it too, under their own
// headers and close buttons.
const PhoneScreens = ({ routes }) => {
  const { pathname } = useLocation()
  const [params] = useSearchParams()
  const page = pathname.replace(/^\/chat\/?/, '')

  if (!page && !params.get('cid')) return null
  return <Screen>{routes}</Screen>
}

// The open thread, and its profile over it. Until the thread the link names
// is the active one (DeepLink reads it), a loader.
export const PhoneThread = () => {
  const { channel } = useChatContext()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const cid = params.get('cid')
  const back = useBack('/chat')
  const backToThread = useBack(threadPath(cid))

  if (channel?.cid !== cid)
    return (
      <>
        <ScreenBar onBack={back} label="Back to chats" />
        <Loader text="Loading chat" />
      </>
    )

  const openProfile = () =>
    navigate(`${threadPath(cid)}&profile=1`, { state: { pushed: true } })

  return (
    <>
      <Channel
        header={<PhoneChannelHeader onBack={back} onProfile={openProfile} />}
      />
      {params.get('profile') === '1' && (
        <Screen layer={2}>
          <ScreenBar onBack={backToThread} label="Back to the chat">
            <Typography sx={{ fontWeight: 700 }}>Profile</Typography>
          </ScreenBar>
          <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
            <UserProfile actions={<ConversationActions />} />
          </Box>
        </Screen>
      )}
    </>
  )
}

export default PhoneScreens
